"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactFeather = require("react-feather");

var _components = require("../components");

var _NavbarSearch = _interopRequireDefault(require("./NavbarSearch"));

var _Layout = require("./Layout.style");

var Navbar = function Navbar(_ref) {
  var expanded = _ref.expanded,
      toggleExpand = _ref.toggleExpand,
      searchData = _ref.searchData,
      toggle = _ref.toggle,
      attachmentData = _ref.attachmentData;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      navbarSearch = _useState2[0],
      setNavbarSearch = _useState2[1];

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Layout.NavbarWrapper, {
    expanded: expanded
  }, !navbarSearch ? /*#__PURE__*/_react.default.createElement(_Layout.NavbarContent, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "navbar-left"
  }, /*#__PURE__*/_react.default.createElement(_reactFeather.Menu, {
    onClick: toggleExpand
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "navbar-center",
    onClick: function onClick() {
      return setNavbarSearch(true);
    }
  }, /*#__PURE__*/_react.default.createElement("span", null, "Search...")), /*#__PURE__*/_react.default.createElement("div", {
    className: "navbar-right"
  }, attachmentData.length ? /*#__PURE__*/_react.default.createElement(_components.Button, {
    text: "Attachments",
    onClick: toggle
  }) : null)) : /*#__PURE__*/_react.default.createElement(_NavbarSearch.default, {
    searchData: searchData,
    setNavbarSearch: setNavbarSearch,
    toggle: toggle
  })));
};

var _default = Navbar;
exports.default = _default;